import { render, staticRenderFns } from "./DelClassDialog.vue?vue&type=template&id=ecd0dfd4&scoped=true&"
import script from "./DelClassDialog.vue?vue&type=script&lang=js&"
export * from "./DelClassDialog.vue?vue&type=script&lang=js&"
import style0 from "./DelClassDialog.vue?vue&type=style&index=0&id=ecd0dfd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd0dfd4",
  null
  
)

export default component.exports